(() => {
  if (window.iuLinkedSeriesInstalled) return;
  window.iuLinkedSeriesInstalled = true;
  const checked = new WeakSet();
  const productIds = new Map();
  const productIdLifetime = 60000;
  function readProductId(url) {
    const key = url.href, cached = productIds.get(key);
    if (cached && (cached.pending || cached.expires > Date.now())) return cached.promise;
    if (cached) productIds.delete(key);
    const entry = { pending: true, expires: 0, promise: null };
    entry.promise = (async () => {
      try {
        const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(8000) });
        if (!response.ok) return null;
        const product = await response.json();
        return /^\d+$/.test(String(product.id)) ? String(product.id) : null;
      } catch { return null; }
    })().then(id => {
      entry.pending = false;
      if (productIds.get(key) === entry) {
        if (id === null) productIds.delete(key);
        else entry.expires = Date.now() + productIdLifetime;
      }
      return id;
    });
    if (productIds.size >= 128) productIds.delete(productIds.keys().next().value);
    productIds.set(key, entry);
    return entry.promise;
  }
  async function verify(nav) {
    if (checked.has(nav)) return;
    checked.add(nav);
    const links = [...nav.querySelectorAll('a[data-series-product]')];
    const results = await Promise.all(links.map(async link => {
      try {
        const url = new URL(link.getAttribute('href'), location.origin);
        if (url.origin !== location.origin || !/\/products\/[^/]+$/.test(url.pathname)) return false;
        url.pathname += '.js';
        url.search = '';
        url.hash = '';
        return await readProductId(url) === link.dataset.seriesProduct;
      } catch { return false; }
    }));
    if (!nav.isConnected) return;
    const currentVisible = links.some((link, i) => results[i] && link.getAttribute('aria-current') === 'page');
    if (!currentVisible || results.filter(Boolean).length < 2) return;
    links.forEach((link, i) => { link.closest('li').hidden = !results[i]; });
    nav.hidden = false;
  }
  function scan(root) {
    if (root.nodeType !== 1) return;
    if (root.matches('[data-iu-linked-series]')) void verify(root);
    root.querySelectorAll('[data-iu-linked-series]').forEach(nav => { void verify(nav); });
  }
  function start() {
    scan(document.documentElement);
    new MutationObserver(changes => changes.forEach(change => change.addedNodes.forEach(scan)))
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
